<template>
<div class="country-table-data">
  <div class="nav-tab">
    <div
      :class="['tab-box', currentTab === index ? 'active': '']"
      v-for="(tab, index) in searchDataFormat"
      :key="index"
      @click="getCurrentTab(index)">{{tab.key}}</div>
  </div>
  <div class="country-content">
    <div class="country-type" v-for="(item, index) in countryContent" :key="index">
      <div class="type">{{item.key}}</div>
      <div class="type-content">
        <span
          class="country-item"
          v-for="(country, countryIndex) in item.value"
          :key="countryIndex"
          @click="goCountry(country.visa_country_id)">{{country.country}}</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import 'pinyin4js';
import Http from '../../libs/http';
import sensorService from '../../services/sensor-service';

export default {
  name: '',
  components: {},
  props: {
    countryList: {
      type: Array,
    },
  },
  data() {
    return {
      innerCountryList: [],
      currentTab: 0,
    };
  },
  computed: {
    searchDataFormat() {
      // 开始造数据 先过滤和排序
      const search = this.countryList || this.innerCountryList;
      const search_filter = search.map(item => ({ visa_country_id: item.visa_country_id, cn_country: item.cn_country, country: item.country }));
      const search_sort = search_filter.sort((pre, current) => {
        if (pre.cn_country < current.cn_country) return -1;
        if (pre.cn_country > current.cn_country) return 1;
        return 0;
      });
      // 按字母分类
      const word_type_country = {};
      search_sort.forEach((item) => {
        const first_letter = item.cn_country.charAt(0).toUpperCase();
        if (!(word_type_country[first_letter] instanceof Array)) {
          word_type_country[first_letter] = [];
        }
        word_type_country[first_letter].push({
          visa_country_id: item.visa_country_id,
          country: item.country,
        });
      });
      // 按tab类型分析
      const tab_type = [
        {
          key: 'ABCD',
          value: [],
        },
        {
          key: 'EFGHJK',
          value: [],
        },
        {
          key: 'LMNO',
          value: [],
        },
        {
          key: 'PQRST',
          value: [],
        },
        {
          key: 'WXYZ',
          value: [],
        },
      ];
      Object.entries(word_type_country).forEach((type) => {
        const [type_key, type_list] = type;
        tab_type.forEach((tabType) => {
          if (tabType.key.indexOf(type_key) > -1) {
            tabType.value.push({
              key: type_key,
              value: type_list,
            });
          }
        });
      });
      return tab_type;
    },
    countryContent() {
      return this.searchDataFormat[this.currentTab].value;
    },
  },
  watch: {},
  created() {
    if (this.countryList === undefined) {
      this.getCountryList();
    }
  },
  methods: {
    getCountryList() {
      Http.post('/sys/visa_country_available_brief_query').then((data) => {
        this.innerCountryList = data.result;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    getCurrentTab(index) {
      this.currentTab = index;
    },
    goCountry(id) {
      const from_type = {
        countries: 'country_list_first_letter',
        index: 'index_first_letter',
      };
      let query = {};
      if (this.$route.name === 'country') {
        // 如果在国家页，保留之前的国家筛选的参数
        query = JSON.parse(JSON.stringify(this.$route.query));
      }
      query.from = from_type[this.$route.name];
      // 商详神策埋点page_from字段----获取当前路由的page_from
      const pageFrom = sensorService.getPageFrom();
      Object.assign(query, pageFrom);
      this.$router.push({ name: 'country', params: { id }, query });
      this.$emit('click-country', { id });
    },
  },
};
</script>

<style scoped lang="less">
.country-table-data{
  width: 626px;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 8px 12px 0px rgba(57,61,70,0.06);
  z-index: 10;
  .nav-tab{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 30px;
    box-shadow: 0px -2px 4px 0px rgba(0,0,0,0.06);
    background: rgba(89, 159, 255, 0.08);
    .tab-box{
      font-size: 16px;
      color: #444;
      cursor: pointer;
      position: relative;
      height: 60px;
      display: flex;
      align-items: center;
      &+.tab-box{
        margin-left: 30px;
      }
      &.active{
        color: #599FFF;
        font-weight: 600;
        &::after{
          content: "";
          width: 30px;
          height: 4px;
          background: #599FFF;
          border-radius: 1px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
  .country-content{
    overflow: auto;
    padding: 20px 0px 0 30px;
    .country-type{
      display: flex;
      align-items: flex-start;
      margin-bottom: 4px;
      .type{
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        color: #599FFF;
        margin-right: 20px;
      }
      .type-content{
        .country-item{
          float: left;
          font-size: 14px;
          line-height: 20px;
          color: #2F333D;
          width: 84px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 6px;
          margin-bottom: 16px;
          cursor: pointer;
          &:hover{
            color: #599FFF;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/country-table-letter.vue